import type { DatasetImageThumbnailProps } from "./dataset-image-thumbnail.type";

import { Typography } from "antd";
import { useTranslation } from "react-i18next";

import { DatasetImageItem } from "@/modules/dataset-image/dataset-image-item";
import { isFileRemoved } from "@/modules/upload-file";

const { Text } = Typography;

export const DatasetImageThumbnail = ({
  imageFile,
  dataset,
}: DatasetImageThumbnailProps) => {
  const { t } = useTranslation();

  if (isFileRemoved(imageFile)) {
    return (
      <Text type="warning">
        {t("dataset:saveToDelete")} {imageFile.name}
      </Text>
    );
  }

  return (
    <DatasetImageItem imageFile={imageFile} dataset={dataset} isThumbnail />
  );
};
